'use client'

import { signOut } from 'aws-amplify/auth'
import { useRouter } from 'next/navigation'
import Link from 'next/link'

/**
 * Component for handling user logout
 */
export const LogoutLink = () => {
  const router = useRouter()

  /**
   * Handle user sign out
   */
  const handleSignOut = async () => {
    await signOut()
    router.push('/login')
  }

  return (
    <Link
      href='#'
      onClick={handleSignOut}
      className='inline-block text-base font-medium text-primary hover:text-primary-dark'
    >
      Logout
    </Link>
  )
}
